import React from 'react'
import '../styles/topNav.css'
import EmailIcon from '../assets/email-icon.svg'
import TelIcon from '../assets/tel-icon.svg'

function TopNav() {
  return (
    <div className='top-nav'>

        <div className="left-section">
            <p>A Leading Oil And Gas Service Provider</p>
        </div>
        <div className="right-section">
          <div className="email">
            <img src={EmailIcon}alt="email-icon" />
          <a href="mailto:your@email.com?subject=Inquiry&body=Hello, I would like to know more about...">info@nextcastlegroup.com</a>
          </div>
        <div className="tel">
          <img src={TelIcon} alt="tel-icon" />
          <a href="tel:+1234567890">+234 8022862128</a>
        </div>
     
        </div>
    </div>
  )
}

export default TopNav